import { apiFetch } from "@core/http";
import type { Welcome, WelcomeInput } from "@core/types";

export type { Welcome, WelcomeInput } from "@core/types";

const base = "/v1/portal/content/welcome";

// SPEC-205 §2/§5: singleton — no hay `id` que buscar ni lista que paginar.
export const getWelcome = () => apiFetch<Welcome>(base);

export const editWelcome = (input: WelcomeInput) =>
  apiFetch<Welcome>(base, { method: "PUT", body: input });
